import axios from 'axios';

export const getBaseURL = () => {
    // Si estamos en desarrollo local (localhost), usamos la URL de la API local
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
    }
    // En producción (chessdrez.com), SIEMPRE usamos la ruta relativa /api
    // Esto evita que apunte a Render por error.
    return '/api';
};

const client = axios.create({
    baseURL: getBaseURL(),
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para añadir el token de autenticación si existe en localStorage
client.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default client;
